import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ng2-bootstrap';

import {RoleEditorComponent} from "./role-editor.component";

@NgModule({
    declarations: [RoleEditorComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        BrowserModule
    ],
    exports: [
        RoleEditorComponent,
    ],
})

export class RoleEditorModule {}


// WEBPACK FOOTER //
// ./src/app/views/role/role-editor/role-editor.module.ts